(() => {
  const initialize = (root) => {
    if (!root || root.dataset.housesReady) return;
    root.dataset.housesReady = 'true';
    const picks = [...root.querySelectorAll('[data-house-pick]')];
    const entries = [...root.querySelectorAll('[data-house-entry]')];
    const images = JSON.parse(root.querySelector('[data-house-images]').textContent);
    const scene = root.querySelector('[data-house-image]');
    const sceneDescriptions = [
      'An entrance with a mirror, coat and wooden bench.',
      'An artisan shelf with useful tools, folded materials and wooden boxes.',
      'Two reading places beside a window overlooking a neighborhood street.',
      'An empty armchair and woven rug beside a warm fireplace.',
      'A studio with an unfinished abstract canvas, an instrument and art materials.',
      'A kitchen counter with a water jug, linen and everyday care items.',
      'Two empty chairs and two cups arranged around a shared table.',
      'A partly open shared chest with two distinct sets of keys.',
      'A sailing vessel departing from a historic harbor.',
      'Stone steps leading into a modest civic building.',
      'A community garden with planting beds and a communal bench.',
      'A sparse retreat room with a daybed and softly draped curtains.'
    ];
    let selected = 1;
    const text = (entry, key) => entry.querySelector('[data-entry-' + key + ']').textContent.trim();
    const setText = (selector, value) => { root.querySelector(selector).textContent = value; };
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    function feedback(element) {
      element.classList.remove('is-updating');
      if (!reduced.matches) {
        void element.offsetWidth;
        element.classList.add('is-updating');
      }
    }
    function select(number, focusPick) {
      selected = ((number - 1 + 12) % 12) + 1;
      root.dataset.selectedHouse = String(selected);
      const entry = entries[selected - 1], opposite = ((selected + 5) % 12) + 1;
      picks.forEach(pick => {
        const active = Number(pick.dataset.housePick) === selected;
        if (active) pick.setAttribute('aria-current', 'true');
        else pick.removeAttribute('aria-current');
      });
      root.querySelectorAll('[data-house-sector]').forEach(path => {
        path.classList.toggle('is-active', Number(path.dataset.houseSector) === selected);
        path.classList.toggle('is-opposite', Number(path.dataset.houseSector) === opposite);
      });
      setText('[data-house-number]', String(selected).padStart(2, '0'));
      setText('[data-detail-number]', String(selected).padStart(2, '0'));
      setText('[data-house-short]', text(entry, 'short'));
      ['title', 'description', 'question', 'type', 'pair'].forEach(key => setText('[data-detail-' + key + ']', text(entry, key)));
      setText('[data-opposite-number]', String(opposite).padStart(2, '0'));
      setText('[data-opposite-title]', text(entries[opposite - 1], 'title'));
      setText('[data-try-label]', 'Try House ' + selected + ' with a planet');
      setText('[data-closing-question]', text(entry, 'question'));
      root.querySelector('[data-detail-link]').setAttribute('href', '#house-' + selected);
      const artwork = images[selected - 1];
      scene.alt = sceneDescriptions[selected - 1];
      scene.srcset = artwork.small + ' 480w, ' + artwork.large + ' 960w';
      scene.src = artwork.large;
      window.WotfResultReflections?.house(root.querySelector('.ah-detail'),selected);
      feedback(root.querySelector('.ah-detail-copy'));
      if (focusPick) focusPick.focus({ preventScroll: true });
    }
    picks.forEach(pick => {
      pick.addEventListener('click', event => { event.preventDefault(); select(Number(pick.dataset.housePick)); });
      pick.addEventListener('keydown', event => {
        const number = Number(pick.dataset.housePick);
        const wheel = pick.closest('.ah-wheel');
        const step = wheel ? 1 : window.matchMedia('(max-width: 700px)').matches ? 2 : 4;
        const offsets = { ArrowRight: 1, ArrowLeft: -1, ArrowDown: step, ArrowUp: -step };
        let next = number + (offsets[event.key] || 0);
        if (event.key === 'Home') next = 1;
        else if (event.key === 'End') next = 12;
        else if (!(event.key in offsets)) return;
        event.preventDefault();
        next = ((next - 1 + 12) % 12) + 1;
        const container = pick.closest('nav') || wheel;
        select(next, container.querySelector('[data-house-pick="' + next + '"]'));
      });
    });
    root.querySelector('[data-opposite]').addEventListener('click', () => select(selected + 6));
    const selectors = ['planet', 'sign', 'house'].map(key => root.querySelector('[data-example-' + key + ']'));
    const result = root.querySelector('[data-example-result]');
    function example() {
      const values = selectors.map(el => el.selectedOptions[0].dataset.phrase.toLowerCase());
      // Preserve the original interpretation pattern and option phrases.
      result.textContent = result.dataset.pattern.replace(/\[(function|style|area)\]/g, (_, key) => values[{ function: 0, style: 1, area: 2 }[key]]);
      const [planet, sign, house] = selectors;
      const planetName = planet.selectedOptions[0].textContent.split(' · ')[0];
      const signName = sign.selectedOptions[0].textContent.split(' · ')[0];
      setText('[data-example-house-name]', text(entries[Number(house.value) - 1], 'title'));
      setText('[data-example-heading]', planetName + ' in ' + signName + ', in House ' + house.value + '.');
      setText('[data-example-question]', text(entries[Number(house.value) - 1], 'question'));
      window.WotfResultReflections?.learning(root.querySelector('[data-example-question]'),planetName,signName,house.value);
      feedback(root.querySelector('.ah-example'));
    }
    selectors.forEach(el => el.addEventListener('change', example));
    root.querySelector('[data-house-try]').addEventListener('click', () => {
      selectors[2].value = String(selected);
      example();
    });
    function openTarget(hash, focus = false) {
      let id;
      try { id = decodeURIComponent(hash.slice(1)); } catch { return; }
      const target = document.getElementById(id);
      if (!target || !root.contains(target)) return;
      let ancestor = target;
      while (ancestor && ancestor !== root) {
        if (ancestor.tagName === 'DETAILS') ancestor.open = true;
        ancestor = ancestor.parentElement;
      }
      const match = /^house-(\d{1,2})$/.exec(id);
      if (match && Number(match[1]) >= 1 && Number(match[1]) <= 12) select(Number(match[1]));
      requestAnimationFrame(() => {
        target.scrollIntoView({ behavior: 'auto', block: 'start' });
        if (focus) {
          const focusTarget = target.tagName === 'DETAILS' ? target.querySelector('summary') : target.querySelector('h2') || target;
          if (!focusTarget.hasAttribute('tabindex')) focusTarget.setAttribute('tabindex', '-1');
          focusTarget.focus({ preventScroll: true });
        }
      });
    }
    root.addEventListener('click', event => {
      const link = event.target.closest('a[href^="#"]');
      if (!link || link.hasAttribute('data-house-pick')) return;
      const hash = link.getAttribute('href');
      if (hash.length < 2) return;
      event.preventDefault();
      history.pushState(null, '', hash);
      openTarget(hash, true);
    });
    function fromHash() { openTarget(location.hash); }
    select(1); example(); fromHash();
    window.addEventListener('hashchange', fromHash);
    window.addEventListener('popstate', fromHash);
    root.addEventListener('shopify:section:unload', () => {
      window.removeEventListener('hashchange', fromHash);
      window.removeEventListener('popstate', fromHash);
    }, { once: true });
  };
  document.querySelectorAll('[data-houses-guide]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => initialize(event.target.querySelector('[data-houses-guide]')));
})();
